export const SET_ACCOUNT_NAV = 'setAccountNav'
export const SET_AUTHENTICATED = 'setAuthenticated'
export const SET_DOMAIN = 'setDomain'
export const SET_INITIALS = 'setInitials'
export const SET_USER_INFOS = 'setUserInfos'
